import { useSessionStorage } from 'usehooks-ts';

export const useLangCheckState = () => {
  const sessionKey = 'lm_lang_check';
  return useSessionStorage(sessionKey, true);
};
